export const LANG = 'lang';
export const DATACENTER_NAME = 'datacenter_name';
export const V1 = '/v1/';

// 頁面路徑
export const PAGE_PATH = {
  LOGIN: `login/`
};
